module.exports = __webpack_public_path__ + "img/1764125046035-KUE ROKO MAMA 3N.jpg.c4c1bc1d.webp";